import { render, staticRenderFns } from "./notifications-dialog.vue?vue&type=template&id=7ce1cf64"
import script from "./notifications-dialog.vue?vue&type=script&lang=js"
export * from "./notifications-dialog.vue?vue&type=script&lang=js"
import style0 from "./notifications-dialog.vue?vue&type=style&index=0&id=7ce1cf64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports